import React from 'react';

export const PreviewFormImage = ({ label, imgUrl = '', info = '' }) => {
  return (
    <li className='PreviewFormItem'>
      <div className='PreviewFormItem__left'>
        <PreviewFormItemLabel>{label}</PreviewFormItemLabel>
      </div>
      <div className='PreviewFormItem__right'>
        <PreviewFormItemImage imgUrl={imgUrl} />
        {info && <div style={{ marginTop: '12px' }}>{info}</div>}
      </div>
    </li>
  );
};

export const PreviewFormText = ({ label, values }) => {
  return (
    <li className='PreviewFormItem'>
      <div className='PreviewFormItem__left'>
        <PreviewFormItemLabel>{label}</PreviewFormItemLabel>
      </div>
      <div className='PreviewFormItem__right'>
        {values.map((value, index) => (
          <PreviewFormItemValue key={index}>{value}</PreviewFormItemValue>
        ))}
      </div>
    </li>
  );
};

export const PreviewFormTel = ({ label, values }) => {
  return (
    <li className='PreviewFormItem'>
      <div className='PreviewFormItem__left'>
        <PreviewFormItemLabel>{label}</PreviewFormItemLabel>
      </div>
      <div className='PreviewFormItem__right'>
        {values.map((value, index) => (
          <PreviewFormItemValue key={index}>
            {value !== '--' && value}
          </PreviewFormItemValue>
        ))}
      </div>
    </li>
  );
};

export const PreviewFormItemLabel = ({ children }) => {
  return <div className='PreviewFormItem__label'>{children}</div>;
};

export const PreviewFormItemImage = ({ imgUrl }) => {
  return (
    <div className='PreviewFormItem__thumbnail'>
      {imgUrl && <img className='PreviewFormItem__image' src={imgUrl} />}
    </div>
  );
};

export const PreviewFormItemValue = ({ children }) => {
  return <div className='PreviewFormItem__value'>{children}</div>;
};

export const PreviewFormTextOpen = ({ label, values }) => {
  return (
    <li className='PreviewFormItem PreviewFormItem--open'>
      <div className='PreviewFormItem__left'>
        <PreviewFormItemLabel>{label}</PreviewFormItemLabel>
      </div>
      <div className='PreviewFormItem__right'>
        {values.map((value, index) => (
          <PreviewFormItemValue key={index}>{value}</PreviewFormItemValue>
        ))}
      </div>
    </li>
  );
};

export const PreviewFormTextChild = ({ label, values, preWrap = false }) => {
  return (
    <li className='PreviewFormItem PreviewFormItem--child'>
      <div className='PreviewFormItem__left'>
        <PreviewFormItemLabel>{label}</PreviewFormItemLabel>
      </div>
      <div
        className={`PreviewFormItem__right PreviewFormItem--child__right ${
          preWrap ? 'PreviewFormItem--pre-wrap' : ''
        }`}
      >
        {values.map((value, index) => (
          <PreviewFormItemValue key={index}>{value}</PreviewFormItemValue>
        ))}
      </div>
    </li>
  );
};

export const PreviewFormTextChildDifference = ({
  label,
  leftValue,
  rightValue,
  header = false,
  isDifferent = false,
}) => {
  return (
    <li
      className={
        header
          ? 'PreviewFormItem PreviewFormItem--child PreviewFormItem--header'
          : 'PreviewFormItem PreviewFormItem--child'
      }
    >
      <div className='PreviewFormItem__left'>
        <PreviewFormItemLabel>{label}</PreviewFormItemLabel>
      </div>
      <div className='PreviewFormItem__right PreviewFormItem__right--double'>
        <PreviewFormItemValue>{leftValue}</PreviewFormItemValue>
      </div>
      <div className='PreviewFormItem__right PreviewFormItem__right--double'>
        <PreviewFormItemValue>
          <span
            className={
              isDifferent &&
              'AgencyRegistrationApplicationForm__difference-text'
            }
          >
            {rightValue}
          </span>
        </PreviewFormItemValue>
      </div>
    </li>
  );
};



// WEBPACK FOOTER //
// ./src/components/PreviewForm.jsx